import wbsBookingsApi from '../apis/wbsBookingsApi';

interface IDeleteActivitiesServiceProps {
  activityId: string;
  isVerified?: boolean;
}

const deleteActivitiesService = async ({
  activityId,
  isVerified,
}: IDeleteActivitiesServiceProps): Promise<void> => {
  await wbsBookingsApi.delete(`/activities/${activityId}`, {
    params: { isVerified },
  });
};

export default deleteActivitiesService;
